export default __webpack_public_path__ + "images/4b3cb9895a8723552fa9fd095cd0e123.png";